import GenericModelField from "./GenericModelField";
import { CompanyTag } from "components/ui/atoms/Tag";
import ModelProvider from "models/ModelProvider";
import { useCompany, useCompanyAsync } from "models/companies/apiCompany";
import CreateCompanyButton from "components/ui/atoms/CreateCompanyButton";

const CompanyField = ({ name, multiple, label, creatable }) => {
  const getCompanyAsync = useCompanyAsync({});

  return (
    <GenericModelField
      name={name}
      multiple={multiple}
      label={label}
      CreateButton={creatable && CreateCompanyButton}
      indexName="company"
      getOptionLabel={(option) => {
        return `${option.best_name} (${option.best_domain})`;
      }}
      getObectFromIdAsync={(id) => {
        return getCompanyAsync(id);
      }}
      renderOption={(props, option) => {
        return (
          <li {...props} key={option.id}>
            {`${option.best_name} (${option.best_domain})`}
          </li>
        );
      }}
      renderTags={(tagValue, getTagProps) => {
        return tagValue.map((option, index) => {
          const { key, ...tagProps } = getTagProps({ index });

          return (
            <ModelProvider
              id={option.id}
              getter={useCompany}
              att_name="company"
              View={CompanyTag}
              key={key}
              {...tagProps}
            />
          );
        });
      }}
    />
  );
};

export default CompanyField;
